// extracted by mini-css-extract-plugin
module.exports = {"content":"s_bl","skipToContentLink":"s_bm"};